import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface UIState {
  sidebarOpen: boolean;
  sidebarCollapsed: boolean;
  darkMode: boolean;
  pageTitle: string;
  breadcrumbs: { label: string; href?: string }[];
}

const initialState: UIState = {
  sidebarOpen: true,
  // GPS-tracker-style default (2026-08-31): the app opens on the icon rail with hover flyouts;
  // the topbar toggle expands to the full accordion drawer when someone wants it.
  sidebarCollapsed: true,
  darkMode: localStorage.getItem('hrms_dark_mode') === 'true',
  pageTitle: 'Dashboard',
  breadcrumbs: [],
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    toggleSidebar: (state) => { state.sidebarOpen = !state.sidebarOpen; },
    setSidebarOpen: (state, action: PayloadAction<boolean>) => { state.sidebarOpen = action.payload; },
    toggleSidebarCollapse: (state) => { state.sidebarCollapsed = !state.sidebarCollapsed; },
    toggleDarkMode: (state) => {
      state.darkMode = !state.darkMode;
      localStorage.setItem('hrms_dark_mode', String(state.darkMode));
    },
    setPageTitle: (state, action: PayloadAction<string>) => { state.pageTitle = action.payload; },
    setBreadcrumbs: (state, action: PayloadAction<{ label: string; href?: string }[]>) => {
      state.breadcrumbs = action.payload;
    },
  },
});

export const { toggleSidebar, setSidebarOpen, toggleSidebarCollapse, toggleDarkMode, setPageTitle, setBreadcrumbs } = uiSlice.actions;
export default uiSlice.reducer;
